module.exports = __webpack_public_path__ + "static/img/北极星环保网.4c1a857.png";


//////////////////
// WEBPACK FOOTER
// ./static/meiti-index/北极星环保网.png
// module id = JzU1
// module chunks = 1